import { Injectable } from '@angular/core';
import { RedirectableFlow } from '@platform-frontend/checkout';
import { LocaleStartParams } from '@platform-frontend/transloco';
import { InvalidStateError } from '@platform-frontend/util';
import { Buffer } from 'buffer';

@Injectable({
  providedIn: 'root'
})
export class AppRoutesService {
  adjustToFlowStartupUrl(url: string): string {
    if (url.startsWith('/checkout') || url.startsWith('/subscription-management') || url.startsWith('/purchase-information')) {
      return this.getBaseRedirectUrl(url) + '/overview';
    } else if (url.startsWith('/academic-registration')) {
      return this.getBaseRedirectUrl(url) + '/academic-registration';
    } else if (url.startsWith('/authentication') && (url.endsWith('/verify-email') || url.endsWith('/o-auth'))) {
      return this.getBaseRedirectUrl(url) + '/sign-in';
    } else {
      return url;
    }
  }

  getRedirectableFlowFromUrl(url: string, params?: LocaleStartParams): RedirectableFlow {
    if (url.startsWith('/checkout')) {
      return { type: 'COMMERCIAL_CHECKOUT', startParams: { ...this.getStartParamsFromUrl(url, '/checkout'), ...params } };
    } else if (url.startsWith('/subscription-management')) {
      return { type: 'SUBSCRIPTION_MANAGEMENT', startParams: { ...this.getStartParamsFromUrl(url, '/subscription-management'), ...params } };
    } else if (url.startsWith('/purchase-information')) {
      return { type: 'PURCHASE_INFORMATION', startParams: { ...this.getStartParamsFromUrl(url, '/purchase-information'), ...params } };
    } else if (url.startsWith('/academic-registration')) {
      return { type: 'ACADEMIC_REGISTRATION', startParams: { ...this.getStartParamsFromUrl(url, '/academic-registration'), ...params } };
    } else {
      throw new InvalidStateError(`Unknown flow for url: ${url}`);
    }
  }

  private getStartParamsFromUrl<T>(url: string, startPath: string): T {
    const pathBeginningWithParams = url.substring(url.indexOf(startPath) + startPath.length + 1);
    const encodedStartParams = decodeURIComponent(pathBeginningWithParams.substring(0, pathBeginningWithParams.indexOf('/')));
    return JSON.parse(Buffer.from(encodedStartParams, 'base64').toString()) as T;
  }

  private getBaseRedirectUrl(url: string): string {
    return url.substring(0, url.lastIndexOf('/'));
  }
}
